import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import { ref } from 'vue';
import { useAxios } from '@/Plugins/axios';
import { useSpinner } from '@/Plugins/spinner';
import { useMitt } from '@/Plugins/mitt';
import SaveCancelButtons from '../../../Components/SaveCancelButtons.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditCreate',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    emits: ['saved', 'cancel'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const axios = useAxios();
        const spinner = useSpinner();
        const emitter = useMitt();
        const localData = ref(Object.assign({}, props.data));
        const orchards = ref([]);
        axios.get('/api/orchards').then((res) => orchards.value = res.data.data);
        const save = () => {
            const url = localData.value.id
                ? `/api/plots/${localData.value.id}`
                : '/api/plots';
            spinner.show();
            axios[localData.value.id ? 'put' : 'post'](url, localData.value)
                .then((res) => {
                emit('saved', res.data.data);
                emitter.emit('plot-saved', res.data.data);
            })
                .catch((err) => {
                console.log(err);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { axios, spinner, emitter, props, emit, localData, orchards, save, get InputText() { return InputText; }, get Dropdown() { return Dropdown; }, SaveCancelButtons };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
